import cookie from 'js-cookie';
import {ACCESS_TOKEN_COOKIE_KEY, REFRESH_TOKEN_COOKIE_KEY} from './constants';

export function getAccessToken(): string {
  return cookie.get(ACCESS_TOKEN_COOKIE_KEY) || '';
}

export function getRefreshToken(): string {
  return cookie.get(REFRESH_TOKEN_COOKIE_KEY) || '';
}

export function setAccessToken(accessToken: string, expires?: number): void {
  cookie.set(ACCESS_TOKEN_COOKIE_KEY, accessToken, {
    sameSite: 'strict',
    expires: expires,
  });
}

export function setRefreshToken(refreshToken: string): void {
  cookie.set(REFRESH_TOKEN_COOKIE_KEY, refreshToken, {
    sameSite: 'strict',
  });
}

export function clearCookies(): void {
  cookie.remove(ACCESS_TOKEN_COOKIE_KEY);
  cookie.remove(REFRESH_TOKEN_COOKIE_KEY);
}
